import { AbstractFWCustomParams } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFWCustomParams';
import { IFWCustomParamsArgument } from 'tag/ts/tag/interfaces/arguments/IFWCustomParamsArgument';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';
import { TFWCustomParams } from 'tag/ts/tag/types/ads/freewheel/TFWCustomParams';

/**
 * @copyright © Paramount Streaming
 * @description Freewheel custom parameters for streaming ads
 */
export class FWCustomParams extends AbstractFWCustomParams {

	/**
	 * @description Internal store for custom ad parameters
	 * @type {TFWCustomParams}
	 * @readonly
	 */
	protected readonly adParams: TFWCustomParams;

	constructor( argument: IFWCustomParamsArgument ) {
		super(
			{
				name: 'FWCustomParams',
				...argument
			}
		);

		switch ( argument?.adSetupInfo?.setup?.definition ) {
			case AdSetupDefinition.IMA:
				this?.logger?.log( 'AdSetupDefinition = IMA' );
				this.adParams = this.createIMAParams();
				break;
			case AdSetupDefinition.DAI_SDK:
			case AdSetupDefinition.DAI_SSB:
				this?.logger?.log( 'AdSetupDefinition = DAI_SDK | DAI_SSB' );
				this.adParams = this.createDAIParams();
				break;
			case AdSetupDefinition.DAI_API:
				this?.logger?.log( 'AdSetupDefinition = DAI_API' );
				this.adParams = this.createDAIAPIParams();
				break;
			case AdSetupDefinition.LINEAR_AD_TRACKING:
				this?.logger?.log( 'AdSetupDefinition = LINEAR_AD_TRACKING' );
				this.adParams = this.createLinearParams();
				this.slotParams = this.createLinearSlotParams();
				this.companionSlotParams = this.createLinearCompanionSlotParams();
				break;
		}
	}

	/**
	 * @description Returns custom parameters for streaming ads
	 * @returns {TFWCustomParams}
	 */
	get adParameters(): TFWCustomParams {
		return this.adParams;
	}
}